import Counter from "./counter";

export default class numberSection {
    constructor(el) {
        if (!this.set(el)) return;
        this.init();
    }

    set(el) {
        if (!el) return false;
        this.root = el;
        this.numbers = this.root.querySelectorAll('[data-numbers-section-item]')

        return true;
    }

    init() {
        this.initObserver();
    }

    initNumbers() {
        if (!this.numbers) return;
        this.numbers.forEach(number => new Counter(number));
    }

    initObserver() {
        this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
            root: null,
            rootMargin: '0px',
            threshold: 0.6,
        })

        this.observer.observe(this.root);
    }

    onIntersect(entries, observer) {
        entries.forEach(entry => {
            const intersecting = entry.isIntersecting;
            if (intersecting) {
                this.initNumbers();
                this.observer.unobserve(this.root);
            }
        }); 
    }
}